
































import Vue from 'vue';
import { State, Getter } from 'vuex-class';
import Component from 'vue-class-component';
import { Refs } from '@/types';

import Header from '@/components/layout/Header/Header.vue';
import SubHeader from '@/components/layout/Header/SubHeader.vue';
import { InfosPSBEN } from '@/store/infosPSBEN/types';
import { VaccinationFolder } from '@/store/folder/types';

@Component({
	components: {
		Header,
		SubHeader
	}
})
export default class StickyHeader extends Vue {
	@Getter('infosPSBEN/getInfosPSBEN') getInfosPSBEN!: InfosPSBEN | undefined;
	@Getter('infosVaccinationFolder/getVaccinationFolder') vaccinationFolder!: VaccinationFolder | undefined;
	@Getter('infosPSBEN/getErrorInfosPSBEN') getErrorInfosPSBEN!: boolean;

	// Extend $refs
	$refs!: Refs<{
		stickyHeader: HTMLElement;
		placeholderDiv: HTMLDivElement;
	}>;

	stickyEnabled = false;

	get hasDataLoaded() {
		if (this.getInfosPSBEN) {
			this.$emit('data-loaded', true);
		}
		return !!this.getInfosPSBEN;
	}

	get hasContextePatient() {
		return this.hasDataLoaded && this.vaccinationFolder;
	}

	created() {
		window.addEventListener('scroll', this.scrollHandler);
	}

	destroyed() {
		window.removeEventListener('scroll', this.scrollHandler);
	}

	scrollHandler(): void {
		// Enable sticky if we've scrolled passed the Header
		if (this.$refs.stickyHeader) {
			this.stickyEnabled = window.pageYOffset > this.$refs.stickyHeader.offsetHeight;
			if (this.stickyEnabled) {
				this.$refs.placeholderDiv.style.height = this.$refs.stickyHeader.offsetHeight + 'px';
			}
		}
	}
}
